import { BodyText } from '@postscript/components';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { api } from '../../../controllers/network/apiClient';
import useAuth from '../../../hooks/useAuth';
import LoadingSpinner from '../../generic/Loading/LoadingSpinner';

interface StyledImageProps {
  size?: string;
}

const StyledImage = styled.img<StyledImageProps>`
  width: ${({ size }) => size || '150px'};
  height: ${({ size }) => size || '150px'};
  border: 4px solid var(--black);
  border-radius: 6px;
`;

interface ShopperDemoQRCodeProps {
  shopId: number;
  size?: string;
}

export const ShopperDemoQRCode: React.FunctionComponent<ShopperDemoQRCodeProps> =
  ({ shopId }) => {
    const { accessToken } = useAuth();

    const [imageUrl, setImageUrl] = useState<string | null>(null);
    const [isError, setIsError] = useState<boolean>(false);

    useEffect(() => {
      let objectUrl: string | null = null;

      const fetchImage = async () => {
        try {
          const response = await api.get(
            `/v2/shopper/config/qr-test/${shopId}/`,
            { responseType: 'blob' },
          );
          objectUrl = URL.createObjectURL(response);
          setImageUrl(objectUrl);
        } catch (error) {
          setImageUrl(null);
          setIsError(true);
        }
      };

      fetchImage();

      return () => {
        if (objectUrl) {
          URL.revokeObjectURL(objectUrl);
        }
      };
    }, [shopId, accessToken]);

    if (isError) {
      return <BodyText color="#fff">Failed to fetch QR Code...</BodyText>;
    }

    return imageUrl === null ? (
      <LoadingSpinner color="#fff" />
    ) : (
      <StyledImage src={imageUrl} />
    );
  };
